import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";
import { useContent } from "../lib/content";

const FAQS = [
    {
        tid: "faq-item-cost",
        q: "Quanto custa para o condomínio?",
        a: "R$ 0. A Conbox instala, opera e mantém todo o mercado — estrutura, equipamentos, estoque e limpeza — sem nenhum investimento ou taxa para o condomínio.",
    },
    {
        tid: "faq-item-energy",
        q: "E o consumo de energia?",
        a: "O consumo do equipamento é medido e reembolsado pela Conbox. O condomínio não tem despesa elétrica adicional por causa da loja.",
    },
    {
        tid: "faq-item-security",
        q: "Como funciona a segurança?",
        a: "O acesso é controlado por QR Code, app ou cartão do condomínio — só entram moradores autorizados. O ambiente conta com monitoramento por câmeras 24 horas.",
    },
    {
        tid: "faq-item-space",
        q: "Quanto espaço é necessário?",
        a: "Trabalhamos com formatos compactos que se adaptam ao condomínio, a partir de aproximadamente 5 m²: na garagem, na área de convivência ou em espaço externo junto à portaria.",
    },
    {
        tid: "faq-item-restock",
        q: "Quem repõe os produtos e faz a limpeza?",
        a: "A equipe própria da Conbox faz a reposição frequente do estoque e a limpeza completa da loja. O síndico não tem nenhuma operação para gerenciar.",
    },
];

export default function Faq() {
    const [open, setOpen] = useState(0);
    const t = useContent().faq;
    const faqs = t.items.map((item, i) => ({ ...FAQS[i], ...item }));

    return (
        <section id="faq" className="scroll-mt-24 bg-[#EFEAE0] py-20 sm:py-28">
            <div className="mx-auto max-w-3xl px-4 sm:px-6">
                <Reveal className="text-center">
                    <SectionTag tone="green">Perguntas dos síndicos</SectionTag>
                    <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-[#1A231E]">
                        {t.title}
                    </h2>
                </Reveal>

                <div className="mt-12 space-y-4">
                    {faqs.map((f, i) => {
                        const isOpen = open === i;
                        return (
                            <Reveal key={f.tid} delay={i * 0.05}>
                                <div
                                    data-testid={f.tid}
                                    className={`rounded-2xl border-2 transition-all duration-300 ${
                                        isOpen
                                            ? "bg-[#F7F4EC] border-[#1A231E] sticker"
                                            : "bg-[#F7F4EC]/60 border-[#1A231E]/12 hover:border-[#1A231E]/30"
                                    }`}
                                >
                                    <button
                                        onClick={() => setOpen(isOpen ? -1 : i)}
                                        className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                                        aria-expanded={isOpen}
                                    >
                                        <span className="text-base sm:text-lg font-extrabold text-[#1A231E]">
                                            {f.q}
                                        </span>
                                        <ChevronDown
                                            className={`w-5 h-5 shrink-0 text-[#F57A3A] transition-transform duration-300 ${
                                                isOpen ? "rotate-180" : ""
                                            }`}
                                        />
                                    </button>
                                    <AnimatePresence initial={false}>
                                        {isOpen && (
                                            <motion.div
                                                initial={{ height: 0, opacity: 0 }}
                                                animate={{ height: "auto", opacity: 1 }}
                                                exit={{ height: 0, opacity: 0 }}
                                                transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                                                className="overflow-hidden"
                                            >
                                                <p className="px-6 pb-6 text-base text-[#1A231E]/75 leading-relaxed">
                                                    {f.a}
                                                </p>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
